// extracted by mini-css-extract-plugin
export default {"card":"N5-z"};